import React, { createContext, useContext, useEffect, useState } from "react"
import ToastNotification from "./ToastNotification"

const ToastContext = createContext()

// Global toast functions reference
let globalToastFunctions = null

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState({
        visible: false,
        message: "",
        type: "info", // "info", "success", "error", "warning"
        duration: 0, // Default to manual dismiss
        position: "bottom", // "top", "bottom", "center"
    })

    const showToast = ({
        message,
        type = "info",
        duration = 0,
        position = "bottom",
    }) => {
        setToast({ visible: true, message, type, duration, position })
    }

    const hideToast = () => {
        setToast((prev) => ({ ...prev, visible: false }))
    }

    useEffect(() => {
        globalToastFunctions = { showToast, hideToast }
    }, [])

    return (
        <ToastContext.Provider value={{ showToast, hideToast }}>
            {children}
            <ToastNotification
                message={toast.message}
                visible={toast.visible}
                onDismiss={hideToast}
                type={toast.type}
                duration={toast.duration}
                position={toast.position}
            />
        </ToastContext.Provider>
    )
}

export const useToast = () => {
    const context = useContext(ToastContext)
    if (!context) {
        throw new Error("useToast must be used within a ToastProvider")
    }
    return context
}

export const Toast = {
    show: ({ message, type = "info", duration = 0, position = "bottom" }) => {
        if (globalToastFunctions?.showToast) {
            globalToastFunctions.showToast({
                message,
                type,
                duration,
                position,
            })
        } else {
            console.warn(
                "ToastProvider not found. Make sure to wrap your app with ToastProvider."
            )
        }
    },

    success: ({ message, duration = 0, position = "bottom" }) => {
        Toast.show({ message, type: "success", duration, position })
    },

    error: ({ message, duration = 0, position = "bottom" }) => {
        Toast.show({ message, type: "error", duration, position })
    },

    warning: ({ message, duration = 0, position = "bottom" }) => {
        Toast.show({ message, type: "warning", duration, position })
    },

    info: ({ message, duration = 0, position = "bottom" }) => {
        Toast.show({ message, type: "info", duration, position })
    },

    hide: () => {
        if (globalToastFunctions?.hideToast) {
            globalToastFunctions.hideToast()
        }
    },
}
